import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/vehicleBlack',
    meta: { title: '车辆黑名单管理' },
    component: Layout,
    redirect: '/vehicleBlack/list',
    children: [
      {
        path: 'list',
        meta: { title: '车辆黑名单管理', activeMenu: '/vehicleBlack' },
        component: () => import('@/views/system/vehicleBlack/List.vue')
      },
      {
        path: 'add',
        meta: {
          title: '新增车辆黑名单',
          activeMenu: '/vehicleBlack'
        },
        component: () => import('@/views/system/vehicleBlack/Add.vue')
      },
      {
        path: 'edit',
        meta: {
          title: '编辑车辆黑名单',
          activeMenu: '/vehicleBlack'
        },
        component: () => import('@/views/system/vehicleBlack/Add.vue')
      },
      {
        path: 'detail',
        meta: {
          title: '车辆黑名单详情',
          activeMenu: '/vehicleBlack'
        },
        component: () => import('@/views/system/vehicleBlack/Detail.vue')
      }

    ]
  }
]
